import React, { useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ReportContainer from './ReportContainer';
import ReactModal from 'react-modal';
import CloseIcon from '../../../assets/icons/close.svg?react';
import { WrapperForIndex, ReportWrapper, CloseButton } from './style';

// Centered with flex rather than `transform: translate(-50%, -50%)`: a transformed
// ancestor becomes the containing block for `position: fixed` descendants, which
// would break ReactGrid's cell editor positioning inside the modal.
const customStyles = {
  content: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    padding: 0,
    border: 'none',
    borderRadius: '24px',
    height: '90%'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: '9999',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export default function ESMAReport() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMultiFunds, setIsMultiFunds] = useState(false);
  const ref = useRef();
  const modalRef = useRef();
  const [searchParams, setSearchParams] = useSearchParams();
  const reportTypeKey = searchParams.get('type') || 'default';

  const onOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = 'hidden';

    const next = new URLSearchParams(searchParams);
    next.set('staticTemplateModalState', 'open');
    setSearchParams(next, { replace: false });
  };

  const onClose = () => {
    setIsOpen(false);
    document.body.style.overflow = 'initial';
    ref.current.refetchAllData();

    const next = new URLSearchParams(searchParams);
    next.set('staticTemplateModalState', 'closed');
    setSearchParams(next, { replace: false });
  };

  const handleChangeIsMultiFunds = value => {
    setIsMultiFunds(value);
  };

  return (
    <>
      <ReportContainer
        hideTables={isOpen}
        ref={ref}
        key="report-1"
        onOpen={onOpen}
        isMultiFunds={isMultiFunds}
        handleChangeIsMultiFunds={handleChangeIsMultiFunds}
        instanceId="main"
      />
      <ReactModal
        id="esma-report-modal"
        isOpen={isOpen}
        onRequestClose={onClose}
        style={customStyles}
      >
        <WrapperForIndex id="esma-report-modal-wrapper">
          <ReportWrapper id="esma-report-modal-content" ref={modalRef}>
            <ReportContainer
              key={`report-2-${reportTypeKey}`}
              onClose={onClose}
              isStaticTemplate={true}
              onOpen={onOpen}
              isMultiFunds={isMultiFunds}
              handleChangeIsMultiFunds={handleChangeIsMultiFunds}
              instanceId="modal"
            />
          </ReportWrapper>
          <CloseButton id="esma-report-modal-close-button" onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </WrapperForIndex>
      </ReactModal>
    </>
  );
}
